export default function Info() {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" className="toast__icon">
			<g clipPath="url(#10)">
				<path
					d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
					fill="white"
				/>
				<path
					d="M7.00006 6.10059C6.80197 6.10059 6.612 6.17928 6.47193 6.31934C6.33186 6.45941 6.25317 6.64938 6.25317 6.84747V10.3202C6.25317 10.5183 6.33186 10.7083 6.47193 10.8483C6.612 10.9884 6.80197 11.0671 7.00006 11.0671C7.19814 11.0671 7.38812 10.9884 7.52819 10.8483C7.66825 10.7083 7.74694 10.5183 7.74694 10.3202V6.84747C7.74694 6.64938 7.66825 6.45941 7.52819 6.31934C7.38812 6.17928 7.19814 6.10059 7.00006 6.10059Z"
					fill="#404040"
				/>
				<path
					d="M6.99988 5.11939C7.46958 5.11939 7.85035 4.73862 7.85035 4.26892C7.85035 3.79922 7.46958 3.41846 6.99988 3.41846C6.53018 3.41846 6.14941 3.79922 6.14941 4.26892C6.14941 4.73862 6.53018 5.11939 6.99988 5.11939Z"
					fill="#404040"
				/>
			</g>
			<defs>
				<clipPath id="10">
					<rect width="14" height="14" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
